<template>
  <base-info-card title="Services">
    <a
      v-for="service in services"
      :key="service"
      :text="service"
      class="mb-8 grey--text body-1 d-block text-none"
      href="#"
      v-html="`&rsaquo; ${service}`"
    />
  </base-info-card>
</template>

<script>
export default {
  name: "SectionservicesAlt",

  data: () => ({
    services: [
      "Application of work permits",
      "Embassy endorsement",
      "Cancellation of work permits",
      "Repatriation of maids",
      "Other foreign worker related services"
    ]
  })
};
</script>
